var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollectingLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 118,
    viewBox: "0 0 237 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5607 73.6635L5.77734 72.2891L4.40295 81.0724L13.1863 82.4468L14.5607 73.6635Z",
    fill: "#FFA8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7864 112.764L33.6523 111.145L32.0326 115.279L36.1667 116.898L37.7864 112.764Z",
    stroke: "#FF6B6B",
    strokeWidth: 1.2642,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4198 7.17953C28.259 7.17953 29.7498 5.68864 29.7498 3.84953C29.7498 2.01042 28.259 0.519531 26.4198 0.519531C24.5807 0.519531 23.0898 2.01042 23.0898 3.84953C23.0898 5.68864 24.5807 7.17953 26.4198 7.17953Z",
    fill: "#FFA8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 91.9708L29.7498 88.3008",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.289 13.2695H40.5586V90.9995H118.289V13.2695Z",
    fill: "#FFC9C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9988 34.6295C56.1088 30.8095 58.4088 26.7795 62.2588 24.7095C64.6688 23.4095 67.4588 23.0295 70.1688 22.6695C74.6688 22.0695 79.1688 21.4695 83.7088 21.4095C86.5588 21.3695 89.5088 21.5695 92.0588 22.8595C93.2788 23.4795 94.3688 24.3295 95.5288 25.0495C96.8888 25.8895 98.3488 26.5695 99.6888 27.4395C102.999 29.5795 105.439 32.8095 107.799 35.9695C108.409 36.7895 109.039 37.6295 109.369 38.5895C109.649 39.4195 109.709 40.3095 109.759 41.1895C110.049 46.2995 110.189 51.4495 109.469 56.5195C108.749 61.5895 107.129 66.6095 104.149 70.7795C100.659 75.6695 95.3788 79.1795 89.6288 80.8995C83.8788 82.6195 77.6588 82.5895 71.8088 81.1995C70.2188 80.8195 68.6288 80.3395 67.1888 79.5595C64.8588 78.2995 62.9988 76.3395 61.1788 74.4095C59.6088 72.7395 58.0388 71.0695 56.4688 69.3995C53.6688 66.4195 50.7988 63.3395 49.2588 59.5495C47.7488 55.8395 47.0088 50.4095 47.7788 46.4295C48.5488 42.5095 52.0588 38.1495 53.9988 34.6295Z",
    fill: "#FFA8A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0083 66.3495C59.3183 67.0295 60.2083 67.2395 60.9483 67.1395C61.6883 67.0395 62.4083 66.7395 63.1583 66.7795C62.7483 67.4495 63.6883 68.2895 64.4483 68.0995C65.2183 67.9095 65.6983 67.1795 66.1083 66.5095C68.5083 62.5595 70.9183 58.6095 73.3183 54.6595C73.4083 54.5195 73.4983 54.3695 73.6483 54.2895C73.8683 54.1795 74.1283 54.2695 74.3683 54.3595C76.0383 54.9695 77.8483 55.1795 79.6183 54.9695C82.3783 54.6395 84.9483 53.2995 87.1183 51.5495C89.2883 49.7995 91.0883 47.6595 92.8483 45.4995C93.5383 44.6495 94.2483 43.7695 95.1983 43.2195C95.6983 42.9395 96.2383 42.7495 96.7383 42.4695C97.8683 41.8295 98.6783 40.7495 99.4483 39.7095C97.3583 37.5195 93.8183 37.4995 90.9383 38.4295C90.4383 38.5895 89.9383 38.7795 89.4183 38.8695C88.9383 38.9495 88.4483 38.9395 87.9583 38.9495C82.2283 39.0595 76.8383 41.4895 71.6283 43.8795C69.3683 44.9195 67.0383 45.9995 65.3383 47.8195C65.3383 47.8195 63.6783 54.6495 66.6883 52.1995C66.9983 51.9495 67.0783 51.4695 67.4683 51.3495C64.0683 55.8995 59.5983 59.5995 56.4883 64.3495",
    fill: "#FF6B6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3477 54.6095C73.2677 55.1095 74.2277 53.8295 75.2777 53.8495C75.6177 53.8595 75.9477 53.9995 76.2677 54.1295C79.6277 55.4595 83.5677 54.4195 86.5277 52.3395C89.4877 50.2595 91.6677 47.2695 93.7477 44.3195",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2793 42.5095C92.9593 42.8895 93.7393 43.0995 94.5193 43.1295C94.9093 43.1395 95.3093 43.1095 95.6693 42.9495C96.1893 42.7295 96.5793 42.2895 96.9693 41.8895C97.8393 40.9995 98.8693 40.1995 100.079 39.8895C101.329 39.5595 102.719 39.7995 103.799 40.5195C104.879 41.2395 105.619 42.4395 105.779 43.7295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8394 37.8795C94.1594 37.9395 93.7694 38.9195 94.2394 39.4195C94.7094 39.9195 95.7194 39.5995 95.8194 38.9295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2188 39.9795C89.6588 38.6595 91.4787 37.6995 93.4187 37.4595C95.3587 37.2195 97.4287 37.7695 98.8787 39.0895",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5489 42.3896C86.2689 41.5396 83.7989 41.1896 81.3689 41.3996C78.5889 41.6296 75.9089 42.5696 73.3489 43.6596C70.1389 45.0296 66.9789 46.7296 64.6289 49.3196",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.998 48.2395C70.568 49.2095 73.248 50.1895 75.988 49.9995C77.038 49.9295 78.068 49.6795 79.118 49.7395",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8281 46.3395C76.4281 48.0495 79.7281 48.6495 82.7681 47.9495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1582 45.9595C80.6682 47.2795 83.7982 47.3595 86.3682 46.1595",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8777 39.8395C83.4377 39.9595 79.0177 40.7995 74.8377 42.2995C74.2377 42.5095 73.5877 42.7995 73.3477 43.3895",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7894 51.8195C66.6494 55.5395 63.6694 59.3895 60.8594 63.3595C61.0794 63.1095 61.3094 62.8595 61.5294 62.6095",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9789 52.3495C72.1589 52.1495 72.2889 51.9195 72.3589 51.6595C69.2389 55.2195 66.3289 58.9695 63.6689 62.8895C63.6089 62.9695 63.5589 63.0795 63.6189 63.1595C63.6789 63.2395 63.8289 63.0995 63.7389 63.0695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1583 52.3695C70.6983 55.6795 68.4683 59.1595 66.4883 62.7795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2793 63.4495C57.4093 64.7595 58.2493 65.9795 59.4293 66.5495C60.6093 67.1195 62.0893 67.0395 63.1993 66.3395C62.9793 66.6595 63.0793 67.1295 63.3593 67.3995C63.6393 67.6695 64.0593 67.7595 64.4493 67.7395C65.9993 67.6595 67.0093 66.1095 67.7493 64.7495C69.5693 61.3995 71.3893 58.0495 73.2093 54.6995",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2793 54.5095C74.1293 57.0995 74.9893 59.6895 75.8393 62.2695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3477 65.7895C73.6777 64.8195 74.4777 64.0095 75.4477 63.6695C76.4177 63.3295 77.5377 63.4495 78.4077 63.9995",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0087 54.7195C78.6387 55.3495 78.2687 55.9695 77.8887 56.5995C79.0287 57.0195 79.9487 57.8895 80.8287 58.7295C82.2387 60.0795 83.6487 61.4295 85.0587 62.7795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0391 65.2695C83.0891 64.7595 83.4091 64.3295 83.7291 63.9395C84.2991 63.2195 84.8891 62.4695 85.7091 62.0495C86.5191 61.6195 87.6291 61.5995 88.2791 62.2495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4177 51.1195C53.2177 51.6495 53.1677 52.2395 53.2677 52.7995C53.2077 52.5895 53.1577 52.3795 53.0977 52.1795C53.6477 51.6695 54.4877 51.6895 55.2377 51.7395C56.3377 51.8195 57.4477 51.8895 58.5477 51.9695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2188 52.4795C54.7687 51.0995 56.1888 49.5695 57.4688 47.9295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7578 47.9295C54.6778 47.6695 56.6278 47.6295 58.5578 47.7995",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7489 42.2395C54.7089 43.0795 54.7289 43.9195 54.7989 44.7595C56.3389 44.8595 57.8789 45.0695 59.3989 45.3895C59.3289 44.7295 59.2589 44.0695 59.1889 43.4095",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 43.0595C56.7289 43.6795 56.6289 44.3095 56.3789 44.8795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3984 40.1096C57.1284 40.4396 58.8884 40.6096 60.6484 40.6096C60.4984 40.4896 60.3584 40.3696 60.2084 40.2496",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5391 37.1295C58.6691 38.2695 59.7891 39.4095 60.9191 40.5495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7383 36.9895C59.2283 37.1895 60.7083 37.3795 62.1983 37.5795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1984 34.1395C60.0384 33.9795 59.7784 33.9195 59.5684 33.9895C60.4784 35.0695 61.3084 36.2095 62.0384 37.4095C61.7584 37.2495 61.5584 36.9395 61.5384 36.6095",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2492 33.3295C59.8992 33.6995 59.5492 34.0695 59.1992 34.4395",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7087 33.7895C62.6487 33.6695 62.4687 33.6395 62.3687 33.7295C62.2787 33.8295 62.3087 34.0095 62.4287 34.0695C62.6187 34.0295 62.8387 33.9595 62.8987 33.7695C62.9487 33.5795 62.6087 33.4195 62.5787 33.6195C62.4687 33.9395 63.0087 34.2095 63.2087 33.9295C63.4087 33.6495 62.9587 33.2395 62.6987 33.4495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0391 30.6595C63.9391 30.0695 64.8391 29.4695 65.7391 28.8795C65.3391 30.5495 65.2591 32.3095 65.5291 34.0095C66.5491 33.3795 67.5391 32.6995 68.4991 31.9795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5781 27.2795C68.4781 28.4895 69.1581 29.8695 69.5781 31.3195C70.3881 30.8395 71.1981 30.3495 72.0081 29.8695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8477 29.0095C69.5677 28.5295 70.3277 28.1095 71.1177 27.7595",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8379 27.1695C68.5079 27.0695 69.1479 26.7795 69.6579 26.3395",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6483 25.1795C73.6283 26.8595 73.4083 28.5295 72.9883 30.1595",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.748 25.4895C73.818 25.2895 73.878 25.0995 73.948 24.8995C75.058 26.2895 76.048 27.7795 76.898 29.3395",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2979 27.6595C74.0579 27.7595 73.8179 27.8595 73.5879 27.9595C74.3579 27.7395 75.1579 27.6295 75.9579 27.6495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4477 28.9995C76.2477 29.0295 76.0477 29.1395 75.9277 29.3095C76.2977 29.3495 76.6777 29.2795 76.9977 29.1095C76.8177 29.0695 76.6277 29.0295 76.4477 28.9995Z",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1581 25.1495C79.0881 24.9995 79.0281 24.8495 78.9581 24.6995C79.0081 26.0695 79.0681 27.4395 79.1181 28.8095C78.8981 28.6195 78.6181 28.4895 78.3281 28.4695C79.1381 28.4095 79.9481 28.3495 80.7581 28.2795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0391 29.4396C83.4791 28.0796 84.8191 26.6096 86.0291 25.0496C86.0791 26.6596 86.4091 28.2696 87.0191 29.7596",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9082 27.6595C84.7582 27.6095 85.6282 27.7795 86.3982 28.1595",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8887 30.2895C88.2487 30.4095 88.6187 30.5295 88.9787 30.6495C88.8387 30.5595 88.7087 30.4595 88.5687 30.3695C89.6287 29.3295 90.3987 27.9995 90.7687 26.5595C90.7587 28.4695 90.9787 30.3895 91.4187 32.2495C92.6487 31.0395 93.6487 29.6095 94.3687 28.0495C94.0887 27.9295 93.8187 27.8095 93.5387 27.6895C93.7787 28.1295 94.1087 28.5295 94.4987 28.8495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9783 29.5195C96.7083 30.0495 97.4383 30.5795 98.1683 31.1095C98.3483 31.2395 98.5183 31.3695 98.6583 31.5395C98.7983 31.7195 98.8683 31.9395 98.9183 32.1595C99.1783 33.3095 98.6183 34.6595 97.5183 35.0695C96.4183 35.4795 94.9783 34.6295 94.9883 33.4595",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.998 30.4795C96.198 30.3095 96.398 30.1395 96.598 29.9695C95.428 31.0595 94.338 32.2295 93.328 33.4695C93.188 33.3495 93.058 33.2295 92.918 33.1095C93.488 33.4395 93.978 33.9095 94.318 34.4695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6676 70.0695C63.7676 70.0995 63.7676 70.2695 63.6676 70.2895C63.5676 70.3095 63.4876 70.1495 63.5676 70.0895C63.7376 69.6595 64.4077 69.5295 64.7177 69.8795C65.0277 70.2195 64.8477 70.8795 64.4077 71.0095C63.9677 71.1395 63.4577 70.6895 63.5377 70.2295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7793 62.3295C71.9593 63.5195 75.4593 63.8795 78.8193 63.3595C86.7293 62.1195 94.9493 62.8895 102.499 65.5795C102.699 65.6495 102.889 65.3295 102.729 65.1795C102.569 65.0295 102.269 65.2195 102.309 65.4295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2092 61.4995C94.5392 62.0395 93.8692 62.5795 93.1992 63.1295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54.748 58.8996C57.288 59.0996 59.878 58.5495 62.128 57.3495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5684 60.4395C57.1884 60.2195 58.8484 60.3795 60.3884 60.9195",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8493 34.7395C55.0093 35.8195 54.1593 36.8995 53.4893 38.0895C52.6793 39.5495 52.1493 41.1495 51.7293 42.7595C49.7893 50.2795 50.3793 58.7695 54.8893 65.0895C55.7293 66.2695 56.6993 67.3595 57.6593 68.4495C62.2293 73.6095 67.3493 79.0895 74.1493 80.2295C78.2793 80.9195 82.4793 79.8995 86.5393 78.8795C89.9093 78.0295 93.3193 77.1795 96.4393 75.6395C99.5593 74.0995 102.419 71.8195 104.029 68.7295C104.699 67.4395 105.139 66.0395 105.549 64.6395C106.549 61.2195 107.389 57.7495 108.079 54.2495C108.659 51.2895 109.119 48.2595 108.809 45.2495C108.489 42.2495 107.309 39.2395 105.049 37.2295C104.519 36.7595 103.929 36.3395 103.439 35.8295C102.409 34.7395 101.899 33.2695 101.169 31.9495C98.8893 27.7895 94.4593 25.1495 89.8593 23.9795C85.2593 22.7995 80.4493 22.9095 75.7093 23.0095C74.4593 23.0395 73.2093 23.0695 71.9793 23.3095C70.4993 23.5995 69.0893 24.1995 67.6993 24.7895C65.5293 25.7095 62.8293 26.3995 61.1193 28.0095C60.1393 28.9395 55.8493 33.4995 55.8493 34.7395Z",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.36 0.36"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3178 70.1095C68.9278 70.0195 68.6478 69.6695 68.3478 69.4095C68.0478 69.1395 67.5678 68.9495 67.2478 69.1895C67.0578 69.3295 66.9878 69.5895 66.9778 69.8295C66.9378 70.5595 67.3278 71.2495 67.4878 71.9595C67.6578 72.6795 67.4778 73.6095 66.7778 73.8295C66.0178 74.0695 65.3178 73.2895 65.0078 72.5495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2084 71.0195C70.3784 72.5695 69.6784 74.1995 69.1484 75.8795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2188 71.5396C73.8288 73.2196 74.4287 74.8895 75.0387 76.5695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0781 76.2896C73.5881 75.0496 74.9381 73.6196 76.1081 72.0496",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2488 72.5595C77.0788 74.1595 77.0388 75.7695 77.1288 77.3695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1977 72.6596C77.1277 72.8096 77.3377 72.9596 77.4977 72.9196C77.6577 72.8796 77.7777 72.7496 77.9077 72.6496C78.4877 72.1996 79.4477 72.5096 79.7577 73.1696C80.0677 73.8296 79.7777 74.6796 79.1977 75.1296C78.6077 75.5696 77.7977 75.6396 77.0977 75.4296",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M81.418 72.5595C81.418 74.1495 81.428 75.7495 81.428 77.3395C82.268 77.2895 83.108 77.1695 83.928 76.9795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5781 75.0695C82.2781 75.2495 83.0281 75.2295 83.7281 75.0095",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5879 72.6795C82.6579 72.6395 83.7279 72.4395 84.7479 72.0795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0292 76.2695C86.4992 76.4995 87.1092 76.3895 87.4892 76.0195C87.2192 75.9595 86.9492 75.8995 86.6792 75.8395C86.6192 74.3995 86.1892 72.9795 85.4492 71.7395C86.8492 73.0995 88.3492 74.3495 89.9392 75.4795C89.7292 73.8295 89.3792 72.1995 88.8992 70.6095C88.6392 70.6795 88.3992 70.8295 88.2092 71.0295C88.8092 71.0595 89.4192 70.8195 89.8292 70.3895",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4992 68.7296C92.8992 69.0696 92.2992 69.4295 91.8492 69.9495C91.3992 70.4695 91.1392 71.1996 91.3492 71.8596C91.6592 72.8396 92.8892 73.2495 93.8992 73.0595C94.4492 72.9595 95.0493 72.6295 95.1193 72.0695",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8291 67.1096C94.5991 67.1196 94.6691 67.4796 94.8091 67.6596C95.6191 68.7196 96.4291 69.7896 97.2391 70.8496C97.8691 70.4296 98.4691 69.9596 99.0191 69.4396",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3493 67.2896C96.9093 67.7296 96.4693 68.1696 96.0293 68.6196",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1683 66.5995C95.6283 66.6695 95.1483 67.0695 94.9883 67.5895",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M100.138 62.1195C100.168 61.4895 99.998 60.8595 99.668 60.3295C100.958 61.2395 102.338 62.0395 103.778 62.7095C103.788 62.4195 103.798 62.1295 103.818 61.8495C103.688 62.3095 103.378 62.7095 102.968 62.9495",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M102.789 56.4695C102.059 56.5595 101.189 56.8195 101.009 57.5395C100.809 58.3295 101.619 58.9895 102.329 59.3895C102.589 59.5395 102.879 59.6795 103.169 59.6395C103.389 59.6095 103.579 59.4795 103.729 59.3195C104.149 58.8695 104.259 58.1595 103.999 57.6095C103.739 57.0495 103.119 56.6895 102.509 56.7195C103.209 57.4395 104.459 57.3595 105.179 58.0695C105.839 58.7195 105.779 59.8595 105.279 60.6395",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M102.428 51.4895C101.898 52.2695 101.858 53.3495 102.308 54.1695C102.768 54.9895 103.708 55.5195 104.648 55.4795C105.368 55.4495 106.088 55.0795 106.458 54.4595C106.828 53.8395 106.778 52.9695 106.268 52.4495C105.768 51.9295 104.828 51.8795 104.328 52.3995C103.858 52.8895 103.868 53.6595 103.978 54.3295",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M101.498 48.2995C102.918 48.8995 104.258 49.6795 105.478 50.6295C105.308 49.5595 105.238 48.4695 105.268 47.3795",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M101.969 48.3995C103.779 48.4095 105.579 48.5195 107.379 48.7295C107.289 48.8295 107.199 48.9295 107.109 49.0395",
    stroke: "#FF8787",
    strokeWidth: 1.3363,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03125 115.211L32.7413 96.8809",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.5508L33.37 31.7708",
    stroke: "#FF6B6B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M142.91 13.3395L190.94 90.5895H204.63V13.3395H142.91Z",
    fill: "#FFC9C9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M204.309 83.6595C222.363 83.6595 236.999 69.0237 236.999 50.9695C236.999 32.9154 222.363 18.2795 204.309 18.2795C186.255 18.2795 171.619 32.9154 171.619 50.9695C171.619 69.0237 186.255 83.6595 204.309 83.6595Z",
    fill: "#FF6B6B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M204.31 80.6895C220.724 80.6895 234.03 67.3834 234.03 50.9695C234.03 34.5556 220.724 21.2495 204.31 21.2495C187.896 21.2495 174.59 34.5556 174.59 50.9695C174.59 67.3834 187.896 80.6895 204.31 80.6895Z",
    fill: "#FFA8A8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M205.738 32.7496C207.918 30.2196 209.928 27.5496 211.738 24.7396",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M186.35 29.5195C187.46 30.1395 188.47 30.9395 189.34 31.8695C189.81 32.3795 190.24 32.9195 190.72 33.4195C191.21 33.9295 191.76 34.3695 192.31 34.8195C193.77 36.0195 195.23 37.2195 196.69 38.4195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M186.939 57.9195C191.489 53.0095 195.689 47.7795 199.479 42.2595",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M214.119 35.4995C220.089 42.1995 225.519 49.3795 230.349 56.9395",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M196.779 36.8495C199.889 35.0695 203.079 33.2695 206.609 32.6595C207.269 32.5495 207.939 32.4795 208.599 32.3995C209.639 32.2895 210.679 32.1795 211.719 32.0695C212.059 32.4195 212.389 32.7595 212.729 33.1095",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M211.42 31.8596C213.47 32.4396 215.53 33.0096 217.58 33.5896C217.48 33.8596 217.11 33.8896 216.83 33.8596C215.35 33.7396 213.86 33.6196 212.38 33.4996",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M216.84 34.7095C216.74 34.7295 216.8 34.5195 216.9 34.5595C217 34.5995 217.01 34.7295 217 34.8395C216.92 36.1295 216.84 37.4295 216.76 38.7195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M212.219 34.2795C212.219 35.4895 212.219 36.6995 212.219 37.8995",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M197.389 35.8495C201.809 35.2695 206.239 34.6795 210.659 34.0995C211.519 33.9895 212.379 33.8695 213.219 33.6495",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M197.369 36.9196C197.559 38.1196 197.749 39.3296 197.939 40.5296",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M197.859 39.7395C202.029 38.9995 206.259 38.5895 210.489 38.5395C211.589 38.5295 212.729 38.5495 213.689 39.0795",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M214.119 40.0295C214.499 41.4695 214.879 42.9195 215.259 44.3595C215.409 44.9195 215.549 45.4795 215.669 46.0395C216.169 48.4895 216.099 51.1195 217.229 53.3595",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M199.539 39.8995C197.769 51.4095 195.989 62.9195 194.219 74.4295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M202.329 70.1795C202.279 68.7795 202.399 67.3695 202.689 65.9895C202.819 65.3695 202.989 64.7295 203.389 64.2395C203.789 63.7495 204.469 63.4295 205.069 63.6395C205.779 63.8795 206.099 64.6895 206.319 65.4095C206.639 66.4195 206.959 67.4895 206.759 68.5295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M189.96 74.8395C189.63 74.9195 190.1 75.3595 190.44 75.2995C199.31 73.9295 207.43 69.3195 214.27 63.5195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M185.529 72.0895C188.409 71.7595 191.239 71.0595 193.939 70.0295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M211.299 63.2296C212.399 63.6796 213.559 63.9595 214.749 64.0695C215.669 64.1595 216.599 64.1396 217.519 64.1196C219.309 64.0896 221.089 64.0495 222.879 64.0195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M222.119 64.0195C224.559 63.4495 227.009 62.9695 229.479 62.5895C229.379 62.7595 229.279 62.9295 229.179 63.1095",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M228.2 63.2695C228.19 63.1095 228.26 62.9495 228.36 62.8295C228.44 64.3595 228.26 65.9095 227.85 67.3795",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M224.068 65.7196C224.208 65.5996 224.218 65.3696 224.098 65.2396C224.088 66.7896 224.208 68.3396 224.478 69.8696",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M224.25 65.2296C224.08 65.1096 223.95 64.9196 223.92 64.7096C224.35 64.6896 224.77 64.6696 225.2 64.6496C225.34 64.6396 225.49 64.6396 225.61 64.7196C225.79 64.8396 225.82 65.0796 225.83 65.2896C225.91 66.4796 225.98 67.6696 226.06 68.8596",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M227.029 57.4995C227.019 57.2895 226.889 57.0995 226.699 57.0095C226.839 58.9195 227.039 60.8295 227.279 62.7295C227.409 62.4295 227.379 62.0595 227.199 61.7795",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M224.83 51.1696C225.93 52.5696 227.02 53.9796 228.1 55.3996C227.74 54.8396 227.38 54.2896 227.02 53.7296",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M225.879 52.3896C225.569 52.2296 225.329 51.9396 225.219 51.6096C223.859 52.8896 222.649 54.3196 221.609 55.8696C221.439 55.8796 221.419 55.5596 221.589 55.5496",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M223.089 53.8796C223.739 53.1096 224.399 52.3396 225.049 51.5596C222.899 52.5296 220.539 53.0496 218.179 53.0696C217.699 53.0696 217.199 53.0596 216.749 53.2396C216.409 53.3696 216.119 53.5996 215.829 53.8196C214.709 54.6296 213.459 55.2396 212.219 55.8396",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M215.178 57.9895C215.078 57.7095 214.988 57.4195 214.888 57.1395C214.818 59.2895 214.908 61.4495 215.158 63.5895",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M223.089 57.0095C222.969 56.7695 222.849 56.5195 222.729 56.2795C222.959 58.4995 223.189 60.7195 223.429 62.9395",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M217.96 65.3795C215.75 67.8995 213.28 70.1795 210.59 72.1695",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M218.16 72.4995C217.17 73.7495 216.06 74.8995 214.84 75.9295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M210.059 52.1696C211.109 51.7896 212.289 51.7696 213.359 52.1196",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M211.229 48.9395C212.059 48.8795 212.889 48.9495 213.699 49.1195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M211.408 44.6795C212.328 44.2595 213.368 44.1195 214.368 44.2695",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M204.318 42.0396C205.558 41.7896 206.838 41.7096 208.108 41.7896",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M210.408 40.8695C211.558 40.7295 212.758 41.0195 213.708 41.6795",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M207.029 56.5696C207.309 56.1596 207.979 56.0796 208.339 56.4296",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M212.389 55.7496C215.409 55.4096 218.499 55.5696 221.469 56.2296",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M189.66 27.6896C190.01 29.3796 190.76 30.9896 191.82 32.3496C190.97 30.4696 189.97 28.6496 188.85 26.9096C189.84 26.7996 190.8 26.4396 191.62 25.8696",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M190.818 29.5195C191.858 28.9095 192.958 28.3995 194.088 27.9695",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M194.488 25.1096C195.248 26.6796 195.998 28.2496 196.758 29.8296",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M196.979 24.1195C198.259 25.4795 199.339 27.0095 200.199 28.6595C200.389 26.6295 200.909 24.6395 201.729 22.7695",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M204.019 23.4095C203.949 25.3095 203.879 27.2095 203.809 29.1195C204.959 28.9695 206.119 28.8195 207.269 28.6695",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M203.648 26.0295C204.938 25.9595 206.238 26.2195 207.398 26.7795",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M203.979 23.3996C204.989 23.0796 206.059 22.9296 207.119 22.9596",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M218.17 28.3395C217.77 27.3595 216.85 26.6095 215.82 26.3995C215.51 26.3395 215.18 26.3195 214.9 26.4495C214.59 26.5895 214.37 26.8695 214.22 27.1695C213.67 28.2295 213.82 29.6195 214.59 30.5395C215.36 31.4595 216.69 31.8595 217.84 31.5095",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M220.829 29.3995C219.669 30.4095 218.599 31.5095 217.609 32.6895C218.439 33.3995 219.259 34.0995 220.089 34.8095",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M219.189 30.9095C220.019 31.4295 220.769 32.0795 221.419 32.8295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M220.689 29.1796C220.779 29.0196 221.029 29.1396 221.169 29.2696C222.039 30.0996 222.919 30.9396 223.789 31.7696",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M220.779 37.0795C222.249 36.1495 223.679 35.1495 225.059 34.0795C225.449 34.3695 225.389 34.9495 225.299 35.4195C225.009 36.9295 224.709 38.4395 224.419 39.9595C225.909 39.0695 227.399 38.1795 228.889 37.2895",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M228.969 39.5596C229.359 41.0996 230.029 42.5596 230.929 43.8696",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M229.969 41.9595C228.439 42.7795 226.769 43.3195 225.049 43.5395",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M226.269 46.1696C226.219 46.6696 226.169 47.1896 226.319 47.6596C226.469 48.1396 226.889 48.5696 227.389 48.5696C227.629 48.5696 227.859 48.4696 228.079 48.3696C228.699 48.0596 229.259 47.6496 229.739 47.1596C230.009 46.8796 230.279 46.5496 230.649 46.4196C231.369 46.1596 232.179 46.7596 232.419 47.4896C232.659 48.2196 232.499 49.0196 232.329 49.7696",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M194.408 76.6496C200.448 77.7696 206.768 78.7096 212.678 77.0196C218.508 75.3496 223.348 71.2796 227.508 66.8596",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M187.039 72.9595C187.779 73.7095 188.599 74.3895 189.479 74.9695",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 67.3195C182.51 67.8295 182.86 68.3395 183.2 68.8495C183.7 69.5895 184.2 70.3295 184.79 71.0095C184.36 70.4495 183.93 69.8995 183.5 69.3395C183.39 69.1995 183.27 69.0295 183.3 68.8495C183.32 68.7195 183.41 68.6095 183.51 68.5095C184.84 67.0795 186.23 65.7095 187.68 64.4095",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M180.779 65.2595C181.969 64.0895 183.099 62.8495 184.149 61.5495C182.629 61.9295 181.069 62.1595 179.509 62.2195C181.009 60.9895 182.209 59.3995 182.979 57.6295C181.249 57.8195 179.509 58.0095 177.779 58.2195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M176.58 51.9095C176.76 53.1995 176.93 54.4795 177.11 55.7695C178.72 55.2595 180.39 54.9195 182.07 54.7695C181.91 53.6495 181.75 52.5195 181.59 51.3995",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M178.779 52.2296C179.199 53.3396 179.489 54.4996 179.639 55.6796",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M181.579 48.2795C179.949 48.5695 178.239 48.3795 176.709 47.7395C177.809 47.0295 178.919 46.3195 180.019 45.6095C180.659 45.1995 181.299 44.7795 181.759 44.1795C180.679 44.0795 179.599 43.9695 178.519 43.8695C177.879 43.8095 177.159 43.6995 176.809 43.1595",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M179.359 40.0795C179.939 38.7695 180.519 37.4595 181.099 36.1395C180.919 36.6695 180.749 37.1995 180.569 37.7295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M180.099 38.3895C179.989 38.5395 179.889 38.6895 179.779 38.8495C181.489 38.8995 183.179 39.4995 184.549 40.5295",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M181.58 34.3096C182.95 34.4696 184.35 34.4096 185.7 34.1196",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M184.959 30.4995C185.109 31.8495 185.259 33.2095 185.409 34.5595C186.489 34.8495 187.429 35.6195 187.939 36.6195",
    stroke: "#FF6B6B",
    strokeWidth: 1.3283,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M127.369 41.0795V90.5895H179.959C179.969 90.5895 141.049 60.8995 127.369 41.0795Z",
    fill: "#FFA8A8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M141.729 13.3395H127.379V20.1595C132.299 14.6995 139.079 13.5595 141.729 13.3395Z",
    fill: "#FFC9C9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M142.87 13.2695C142.87 13.2695 142.43 13.2695 141.73 13.3295H142.91L142.87 13.2695Z",
    fill: "#FFA8A8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M142.91 13.3395H141.73C139.08 13.5695 132.3 14.6995 127.38 20.1595C125.49 22.2495 123.87 24.9495 122.88 28.5095C122.02 31.6195 123.89 36.0395 127.38 41.0895C141.05 60.9095 179.97 90.5995 179.97 90.5995H190.94L142.91 13.3395Z",
    fill: "#FFE3E3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M142.25 51.3495L161.73 70.8296",
    stroke: "white",
    strokeWidth: 1.771,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M167.039 76.1395L177.669 84.9995",
    stroke: "white",
    strokeWidth: 1.771,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M132.44 113.479C140.403 113.479 146.86 107.023 146.86 99.0593C146.86 91.0954 140.403 84.6393 132.44 84.6393C124.476 84.6393 118.02 91.0954 118.02 99.0593C118.02 107.023 124.476 113.479 132.44 113.479Z",
    fill: "#FF6B6B"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M133.19 111.609C141.153 111.609 147.61 105.153 147.61 97.1894C147.61 89.2254 141.153 82.7693 133.19 82.7693C125.226 82.7693 118.77 89.2254 118.77 97.1894C118.77 105.153 125.226 111.609 133.19 111.609Z",
    fill: "#FFC9C9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M128.119 100.619C132.329 103.549 138.099 102.519 141.029 98.3193",
    stroke: "#FF6B6B",
    strokeWidth: 1.2642,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M123.62 88.0594L126.67 90.4694L130.39 89.3194L129.04 92.9694L131.29 96.1494L127.4 95.9894L125.07 99.1094L124.01 95.3694L120.33 94.1094L123.56 91.9494L123.62 88.0594Z",
    fill: "#FF6B6B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M133.359 86.8994L137.179 86.1694L138.749 82.6094L140.629 86.0094L144.499 86.3994L141.839 89.2394L142.669 93.0394L139.149 91.3894L135.789 93.3494L136.269 89.4894L133.359 86.8994Z",
    fill: "#FF6B6B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5898 50.4102C10.5898 50.4102 22.7098 64.6302 41.3698 52.9102",
    stroke: "#FF6B6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4995 55.3501L41.0895 53.0301L38.7695 52.4401L39.9995 51.7001L42.3295 52.2901L41.7395 54.6201L40.4995 55.3501Z",
    fill: "#FF6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectingLeftImage);
export default __webpack_public_path__ + "static/media/collectingLeftImage.9f334655bc098be10786926d37a06aaf.svg";
export { ForwardRef as ReactComponent };